import { NotificationInstance } from "antd/es/notification/interface"
import { showGlobalAlert } from '../components/common/Popup/useAlertPopup'

let notificationApi: NotificationInstance | null = null

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const setNotificationApi = (api: NotificationInstance) => {
  notificationApi = api
}

/**
 * Show a popup notification alert
 * @param type Type of notification
 * @param description Alert description
 * @param actionButton Optional action button configuration
 */
export const showAlert = (
  type: NotificationType,
  description?: string,
  actionButton?: { text: string, onClick: () => void }
) => {
  const message = description || ''
  // Auto-detect HTML. AlertPopup will render accordingly; this detection is just for potential future hooks
  const _isHtml = typeof message === 'string' && /<\/?[a-z][\s\S]*>/i.test(message)

  // Always use popup alerts (AlertPopup auto-detects HTML and renders safely)
  showGlobalAlert(type as any, message, actionButton)
}
